<form [formGroup]="form" class="row">
  @for (question of questions; track question) {
    <div class="form-group" [ngClass]="{'col-md-6': !question.fullsize }">
      <ls-field [question]="question" [form]="form"></ls-field>
    </div>
  }
</form>
